<template>
    <div>
        <div class="">
            <h2>
                Confirm New Payment
            </h2>
            <table class="uk-table uk-table-small uk-table-justify">
                <tr>
                    <th class="uk-width-1-3">
                        Job ID:
                    </th>
                    <td>{{ paymentDetails.jobNumber }}</td>
                </tr>
                <tr>
                    <th>Payment State:</th>
                    <td>{{ paymentDetails.paymentState }}</td>
                </tr>
                <tr>
                    <th>Payment Type:</th>
                    <td>{{ paymentType }}</td>
                </tr>
                <tr>
                    <th>Payment Method:</th>
                    <td>{{ paymentDetails.paymentMethodDisplayTitle }}</td>
                </tr>
                <tr>
                    <th>Amount:</th>
                    <td>
                        ${{ amount }}
                    </td>
                </tr>
                <template v-if="paymentDetails.isCCPayment">
                    <tr>
                        <th>
                            Transaction Fee:
                            <span
                                uk-icon="info"
                                :uk-tooltip="paymentDetails.surchargeNote"
                            />
                        </th>
                        <td>
                            ${{ transactionFee }}
                        </td>
                    </tr>
                    <tr>
                        <th>Total Amount:</th>
                        <td>
                            ${{ totalAmount }}
                        </td>
                    </tr>
                </template>
                <tr v-if="paymentDetails.notes">
                    <th>Description:</th>
                    <td>{{ paymentDetails.notes }}</td>
                </tr>
            </table>

            <div
                v-if="paymentDetails.isChequePayment"
            >
                <h3>Cheque Details</h3>
                <table
                    class="uk-table uk-table-small uk-table-justify"
                >
                    <tr>
                        <th class="uk-width-1-3">
                            Bank:
                        </th>
                        <td>{{ paymentDetails.cheque.bank }}</td>
                    </tr>
                    <tr>
                        <th>Branch:</th>
                        <td>{{ paymentDetails.cheque.branch }}</td>
                    </tr>
                    <tr>
                        <th>Drawer:</th>
                        <td>{{ paymentDetails.cheque.drawer }}</td>
                    </tr>
                </table>
            </div>


            <div
                v-if="paymentDetails.isCCPayment"
            >
                <div v-if="paymentDetails.emailBpointPaymentLink">
                    <h3>Credit Card Payment Link</h3>
                    <table
                        class="uk-table uk-table-small uk-table-justify"
                    >
                        <tr>
                            <th class="uk-width-1-3">
                                Email:
                            </th>
                            <td>{{ paymentDetails.payer.user.email }}</td>
                        </tr>
                    </table>
                </div>
                <div v-else>
                    <h3>Credit Card Details</h3>
                    <table
                        class="uk-table uk-table-small uk-table-justify"
                    >
                        <tr>
                            <th class="uk-width-1-3">
                                Cardholder Name:
                            </th>
                            <td>{{ paymentDetails.cc.cardholderName }}</td>
                        </tr>
                        <tr>
                            <th>Card Number:</th>
                            <td>{{ ccNumber }}</td>
                        </tr>
                        <tr>
                            <th>CVN:</th>
                            <td>{{ maskData(paymentDetails.cc.cvn) }}</td>
                        </tr>
                        <tr>
                            <th>Expiry:</th>
                            <td>{{ maskData(paymentDetails.cc.expiryMonth) }}/{{ maskData(paymentDetails.cc.expiryYear) }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <h3>{{ paymentDetails.isUserDetailRetrieved ? '' : 'Additional ' }}Customer Details</h3>
            <div>
                <table
                    class="uk-table uk-table-small uk-table-justify"
                >
                    <tr>
                        <th class="uk-width-1-3">
                            Name:
                        </th>
                        <td>{{ fullName(paymentDetails.payer.user) }}</td>
                    </tr>
                    <tr>
                        <th>Email:</th>
                        <td>{{ paymentDetails.payer.user.email }}</td>
                    </tr>
                    <tr>
                        <th>Mobile Number:</th>
                        <td>{{ paymentDetails.payer.user.mobile_number }}</td>
                    </tr>
                    <tr>
                        <th>Address: </th>
                        <td>{{ fullAddress(paymentDetails.payer.address) }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { kebabCaseToWords, formatPrice } from "@strangeanimals/common-vue-components/src/helpers/helpers";

export default {
    name: "PaymentSummary",
    props: {
        paymentDetails: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },

    computed: {
        amount() {
            return formatPrice(this.paymentDetails.amountWithoutSurcharge);
        },
        transactionFee() {
            return formatPrice(this.paymentDetails.surchargeAmount);
        },
        totalAmount() {
            return formatPrice(this.paymentDetails.amountWithoutSurcharge + this.paymentDetails.surchargeAmount);
        },
        paymentType() {
            return this.paymentDetails.paymentType ? kebabCaseToWords(this.paymentDetails.paymentType) : "";
        },
        ccNumber() {
            let cc = this.paymentDetails.cc.cardNumber;
            cc = this.maskData(cc.slice(0,12)) + cc.slice(cc.length - 4);
            cc = cc.match(/.{1,4}/g);
            return cc.join(' ');
        },
    },

    methods: {
        showUserTable(index){
            return ((index === 0) || (index === 1 && this.paymentDetails.isAlternateUserIncluded))
        },

        fullName(user){
            return user.title + " " + user.first_name + " " + user.surname;
        },

        fullAddress(address){
            if (address.address_1) {
                let fullAddress = address.address_2 ? address.address_1 + " " + address.address_2 : address.address_1;
                return fullAddress + ", " + address.suburb + ", " + address.state + " " + address.postcode;
            } else {
                return '';
            }
        },

        maskData(data) {
            return data.replace(/[0-9]/g, "X");
        }
    }
}
</script>
